// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media (max-width: 768px) {
    .profile-page {
      padding: 10px !important;
    }
    
    .profile-page > div:last-child {
      padding: 20px !important;
    }
    
    .profile-page h2 {
      font-size: 20px !important;
    }
    
    .profile-page span[style*="width: 160px"] {
      min-width: 120px !important;
    }
  }
  
  @media (max-width: 480px) {
    .profile-page {
      padding: 5px !important;
    }
    
    .profile-page > div:last-child {
      padding: 15px !important;
    }
    
    .profile-page h2 {
      font-size: 18px !important;
    }
    
    .profile-page button {
      padding: 8px 12px !important;
      font-size: 11px !important;
    }
    
    .profile-page input {
      font-size: 14px !important;
      padding: 8px 10px !important;
    }
  }
  
 
  @media (max-width: 380px) {
    .profile-page span[style*="min-width: 140px"] {
      min-width: 100px !important;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/profile/Profile.css"],"names":[],"mappings":";AACA;IACI;MACE,wBAAwB;IAC1B;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,4BAA4B;MAC5B,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;MAC1B,4BAA4B;IAC9B;EACF;;;EAGA;IACE;MACE,2BAA2B;IAC7B;EACF","sourcesContent":["\r\n@media (max-width: 768px) {\r\n    .profile-page {\r\n      padding: 10px !important;\r\n    }\r\n    \r\n    .profile-page > div:last-child {\r\n      padding: 20px !important;\r\n    }\r\n    \r\n    .profile-page h2 {\r\n      font-size: 20px !important;\r\n    }\r\n    \r\n    .profile-page span[style*=\"width: 160px\"] {\r\n      min-width: 120px !important;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 480px) {\r\n    .profile-page {\r\n      padding: 5px !important;\r\n    }\r\n    \r\n    .profile-page > div:last-child {\r\n      padding: 15px !important;\r\n    }\r\n    \r\n    .profile-page h2 {\r\n      font-size: 18px !important;\r\n    }\r\n    \r\n    .profile-page button {\r\n      padding: 8px 12px !important;\r\n      font-size: 11px !important;\r\n    }\r\n    \r\n    .profile-page input {\r\n      font-size: 14px !important;\r\n      padding: 8px 10px !important;\r\n    }\r\n  }\r\n  \r\n \r\n  @media (max-width: 380px) {\r\n    .profile-page span[style*=\"min-width: 140px\"] {\r\n      min-width: 100px !important;\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
